import { Injectable } from '@angular/core';
  
@Injectable({ providedIn: 'root' })

export class FileService {

  downloadFile(data, fields, filename = 'data') {
    let csvData = this.convertToCSV(data, fields);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  private capitalizeFirst(s: string) {
    if (typeof s !== 'string') return ''
    if (s.length === 2) {
      return s.toUpperCase();
    }
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  private convertToCSV(objArray, headerList) {
    let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';

    for (let index in headerList) {
      row += this.capitalizeFirst(headerList[index]) + ',';
    }

    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line =  '';
      for (let index in headerList) {
        let head = headerList[index];
        if (array[i][head] !== null)
          line += '"' + array[i][head] + '"' + ',';
        else {
          line += '"",';
        }
      }
      str += line + '\r\n';
    }
    return str;
  }

}
